import React from 'react';
import ReactDOM from 'react-dom';
import 'generic/index.css';
import reportWebVitals from 'reportWebVitals';
import { overrideRessource } from 'generic/utils/utils';

const App = overrideRessource('App');

ReactDOM.render(
  // eslint-disable-next-line react/jsx-filename-extension
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
